const fetchAdvices = ({ http, categoryId }) => http({
  url: `/advices/categories/${categoryId}/posts`
})
  .then(({ data }) => data)
  .then(({ posts }) => posts);

export default fetchAdvices;
